import classNames from "lib/classNames";
import CountBadge from "../ui/CountBadge";

type Tab = {
  name: string;
  href: string;
  count?: string | number;
};
interface Props {
  tabs: Tab[];
  activeTab: string;
  onTabChange?: (tab: string) => void;
}

export default function TabBar({ tabs, activeTab, onTabChange }: Props) {
  return (
    <>
      <div className="border-b-2 border-gray-300 dark:border-gray-600">
        <nav className="-mb-px flex">
          {tabs.map((tab) => (
            <a
              key={tab.name}
              href={tab.href}
              data-name={tab.name}
              onClick={(e) => {
                if (onTabChange) {
                  e.preventDefault();
                  onTabChange(e.currentTarget.dataset.name);
                }
              }}
              className={classNames(
                "text-lg leading-6 border-b-2 font-bold py-2 px-4 -mb-px",
                tab.name === activeTab
                  ? "text-indigo-600 border-indigo-300 dark:text-yellow-50 dark:border-yellow-300"
                  : "dark:text-gray-400 border-transparent hover:text-gray-500 dark:hover:text-white"
              )}
              aria-current={tab.name === activeTab ? "page" : undefined}
            >
              {tab.name}
              {tab.count ? (
                <CountBadge count={Number(tab.count)} active={tab.name === activeTab} />
              ) : null}
            </a>
          ))}
        </nav>
      </div>
    </>
  );
}
